import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, input, output, signal } from '@angular/core';
import { BeneficioOpcao } from '../../../../core/models/parametros/beneficios.model';
import { VivestModalAreaVisivelDirective } from '../../../../shared/directives/modal-vivest/vivest-modal-area-visivel.directive';

/** Seleção múltipla; os benefícios que já estão no plano aparecem desabilitados. */
@Component({
  selector: 'app-beneficios-modal',
  standalone: true,
  imports: [VivestModalAreaVisivelDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './beneficios-modal.component.html',
  styleUrl: './beneficios-modal.component.scss',
})
export class BeneficiosModalComponent {
  readonly opcoes = input.required<readonly BeneficioOpcao[]>();
  /** Ids dos benefícios que já estão no plano. */
  readonly jaIncluidos = input<readonly number[]>([]);
  readonly carregando = input(false);

  readonly adicionar = output<BeneficioOpcao[]>();
  readonly fechar = output<void>();

  readonly selecionados = signal<ReadonlySet<number>>(new Set());
  readonly totalSelecionado = computed(() => this.selecionados().size);

  jaIncluido(opcao: BeneficioOpcao): boolean {
    return this.jaIncluidos().includes(opcao.id);
  }

  alternar(opcao: BeneficioOpcao): void {
    if (this.jaIncluido(opcao)) {
      return;
    }
    const proximos = new Set(this.selecionados());
    if (!proximos.delete(opcao.id)) {
      proximos.add(opcao.id);
    }
    this.selecionados.set(proximos);
  }

  confirmar(): void {
    // Na ordem do catálogo, não na ordem em que foram marcados.
    const escolhidos = this.opcoes().filter((opcao) => this.selecionados().has(opcao.id));
    if (escolhidos.length) {
      this.adicionar.emit(escolhidos);
    }
  }
}
